import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { Page } from "types/dto/Page";
import { RegistroCondominioDTO } from "types/dto/RegistroCondominioDTO";
import { RequestCondominiosPaginados } from "types/request/RequestCondominiosPaginados";

export const useGetCondominiosPaginados = (request: RequestCondominiosPaginados) => {
  const onError = () => {
    toast.error("Erro ao buscar condomínios");
  };

  const config = {
    staleTime: 1000 * 60 * 60 * 1,
    retry: 2,
  };
  
  return useFetch<Page<RegistroCondominioDTO>>({
    key: ["condominios-paginados", request.nomeCondominio, request.page, request.sort],
    url: api.condominio.getCondominiosPaginados,
    params: request,
    enabled: true,
    onError,
    config,
  });
};
